// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { InfoOutlined } from '@/constants/hardfin-standard-icons';
import { Box, IconButton, Tooltip } from '@mui/material';
import { DateTime } from 'luxon';

interface Props {
  /**
   * Information about who created the cost and when
   */
  createdBy: {
    firstName: string | null;
    lastName: string | null;
  };
  createdAt: DateTime;

  /**
   * Information about who last updated the cost and when
   */
  lastUpdatedBy: {
    firstName: string | null;
    lastName: string | null;
  };
  lastUpdatedAt: DateTime;

  /**
   * Whether to show the tooltip as an icon button (default) or just the icon
   */
  showAsButton?: boolean;
}

/**
 * A tooltip component that displays cost creation and update information
 * in a consistent format across the application.
 */
export function CostInfoTooltip(props: Props) {
  const formattedLastUpdated = props.lastUpdatedAt.toFormat(
    'MMMM d, yyyy @ hh:mm:ss a (z)'
  );

  const formattedCreatedAt = props.createdAt.toFormat(
    'MMMM d, yyyy @ hh:mm:ss a (z)'
  );

  const tooltipContent = (
    <Box>
      Reported by {props.createdBy.firstName || 'Unknown'}{' '}
      {props.createdBy.lastName || 'User'} <br />
      Created on {formattedCreatedAt} <br />
      Last updated by {props.lastUpdatedBy.firstName || 'Unknown'}{' '}
      {props.lastUpdatedBy.lastName || 'User'} <br />
      Last updated on {formattedLastUpdated}
    </Box>
  );

  const icon = <InfoOutlined fontSize="small" />;

  return (
    <Tooltip arrow placement="top" title={tooltipContent}>
      {props.showAsButton !== false ? (
        <IconButton size="small">{icon}</IconButton>
      ) : (
        icon
      )}
    </Tooltip>
  );
}
